import jwtDecode from 'jwt-decode';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { globalOp } from 'store/ducks/Global';
import Helpers from 'utils/Helpers';
import SuperAdmin from './SuperAdmin';

const SuperAdminRedirect = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get('token');
    const storedToken = Helpers.getToken();

    try {
      const token = tokenFromUrl || storedToken;

      if (!token) {
        navigate('/', { replace: true });
        return;
      }

      jwtDecode(token);

      if (tokenFromUrl) {
        sessionStorage.setItem('user', JSON.stringify({ token }));
      }

      dispatch(globalOp.setSuperAdmin(true));
      setReady(true);
    } catch {
      sessionStorage.removeItem('user');
      navigate('/', { replace: true });
    }
  }, [dispatch, location.search, navigate]);

  if (!ready) return null;

  return <SuperAdmin />;
};
export default SuperAdminRedirect;
